import * as React from 'react';

/**
 * handles keypress in keyboard navigation
 * @param {HTMLEvent} event - The keyDown event
 * @param {Function} cb - A callback function to be executed on pressing Enter or Space
 */
const handleKeyPress = (event: React.KeyboardEvent<HTMLElement>, cb: Function, preventDefault = false) => {
    event.stopPropagation();
    const element = document.activeElement as HTMLElement;

    const { key } = event;

    switch (key) {
        case 'Enter':
            return cb();
        case ' ':
            if (preventDefault) {
                event.preventDefault();
            }

            return cb();
        case 'ArrowRight':
        case 'ArrowDown':
            preventDefault && event.preventDefault();
            if (element.nextElementSibling) {
                (element.nextElementSibling as HTMLElement).focus();
            }

            break;
        case 'ArrowLeft':
        case 'ArrowUp':
            preventDefault && event.preventDefault();
            if (element.previousElementSibling) {
                (element.previousElementSibling as HTMLElement).focus();
            }

            break;
        case 'Escape':
            element.blur();
    }

    return null;
};

export default handleKeyPress;
